export default {"src":"/_next/static/media/sustainability_compliance_monitoring.90384fd5.svg","height":31,"width":31,"blurWidth":0,"blurHeight":0};